export const NAMESPACE = 'ADMIN_CONTACTS/';

export const SET_SEARCH_TYPE = NAMESPACE + 'SET_SEARCH_TYPE';
export const SET_GROUPS_SOURCE = NAMESPACE + 'SET_GROUPS_SOURCE';
export const SET_SEARCH_QUERIES_SOURCE = NAMESPACE + 'SET_SEARCH_QUERIES_SOURCE';
export const SET_SEARCH_FILTER_COMMUNITY = NAMESPACE + 'SET_SEARCH_FILTER_COMMUNITY';
